var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hints.length > 0)?_c('div',{staticClass:"w-100 d-flex flex-column mb-3"},_vm._l((_vm.uniquifyHints(_vm.hints)),function(item,index){return _c('information-item',{key:`hint-${index}`,attrs:{"type":item.type,"message-id":item.messageId,"fill-in-data":item.fillInData}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }